import { render, staticRenderFns } from "./comments_list_right.vue?vue&type=template&id=6d45d808&scoped=true"
import script from "./comments_list_right.vue?vue&type=script&lang=js"
export * from "./comments_list_right.vue?vue&type=script&lang=js"
import style0 from "./comments_list_right.vue?vue&type=style&index=0&id=6d45d808&prod&scoped=true&lang=less"
import style1 from "./comments_list_right.vue?vue&type=style&index=1&id=6d45d808&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d45d808",
  null
  
)

export default component.exports